
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'NACA',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NACA.vue